import { useSharedDocumentApi } from '@/features/api/hooks/shared-document/useSharedDocumentApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDeleteTemporaryDocumentItem = () => {
  const api = useSharedDocumentApi();

  return useApiMutation({
    mutationFn: (temporaryDocumentItemId: string) =>
      api.deleteTemporaryDocumentItem({ temporaryDocumentItemId }),
    onError: (e) =>
      console.error(
        '[useDeleteTemporaryDocumentItem]: temporary document delete failed',
        e
      )
  });
};
